import { CLEAR_FUNCTION_MARKERS } from "../../../enums/Request/leader.requests.types";

export const clearFunctionMarkersAction = () => {
    return {
        type: CLEAR_FUNCTION_MARKERS,
    };
};